// Is C's retention queue switched on for this tenant? The route is C's leg and is
// not live yet; the web must not probe for it on every dashboard and every
// customer window (each probe is a 404 in the console). So the at-risk layer
// reads a flag: the industry registry's `retentionQueue` feature (flipped when C's
// leg ships), or a per-browser override for QA. No flag → no request, no tile,
// no banner, no cards.
import { getFeatures, getIndustryKey } from "../constants/uiRegistry";

export function isRetentionQueueEnabled() {
  try {
    if (localStorage.getItem("abon.features.retentionQueue") === "1") return true;
  } catch { /* private mode */ }
  try {
    return Boolean(getFeatures(getIndustryKey("general"))?.retentionQueue);
  } catch {
    return false;
  }
}
